<template>
  <div class="card mb-4">
    <div class="flex flex-col py-6 px-2 sm:px-4 text-center items-center">
      <h2 class="text-gray-700 mb-2 text-lg sm:text-xl">
        {{ $t('WorkshopComponent.noWorkshopHeading', { text: featureName }) }}
      </h2>
      <p class="text-gray-500 mb-4 text-sm sm:text-base">
        {{ $t('WorkshopComponent.noWorkshopText', { text: featureName }) }}
      </p>
      <Button @click.prevent="openCreateChoicePopup" type="button" id="newWorkshopButton"
        class="btn-primary-accent py-2.5 px-5 text-base sm:text-lg w-48" unstyled>
        {{ $t('WorkshopComponent.newWorkshopButton', { text: featureName }) }}
      </Button>
    </div>
  </div>
</template>
<script>
import { Button } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'NoWorkshopComponent',
  components: { Button },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'workshops',
        this.$t('FallbackTexts.workshop'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {
    async openCreateChoicePopup() {
      // Prevent multiple taskCreator overlays from being created
      const existingOverlays = this.$store.getters.getFrontendOverlays;
      const hasTaskCreatorOverlay = existingOverlays.some((overlay) => overlay.type === 'taskCreator');
      if (hasTaskCreatorOverlay) {
        return;
      }

      window.scrollTo(0, 0);
      await this.$store.commit('setSelectedCreateTab', 'workshops');
      this.$store.commit('addFrontendOverlay', {
        id: Math.random(),
        type: 'taskCreator',
      });
    },
  },
};
</script>
